/**
 * Event listener registration layer for product linker.
 */
import type { ProductLinkerForm } from "./product-linker-form";
import type { ProductLinkerHandler } from "./product-linker-handler";
import type { ProductLinkerProduct } from "./product-linker-api";

class ProductLinkerListener {
    public static bindThumbImageError(img: HTMLImageElement, onError: () => void): void {
        img.addEventListener("error", onError, { once: true });
    }

    public form: ProductLinkerForm;
    public handler: ProductLinkerHandler;

    public constructor(form: ProductLinkerForm, handler: ProductLinkerHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const openBtn = this.form.getOpenButton();
        const clearBtn = this.form.getClearButton();
        const searchInput = this.form.getSearchInput();

        if (openBtn) {
            openBtn.addEventListener("click", this.handler.handleOpenClick.bind(this.handler));
        }

        // Clicking the preview area (e.g. the product card in edit mode) focuses the search input.
        // Skip anchor clicks so product/brand/category links still navigate normally.
        const previewEl = this.form.getPreviewElement();
        if (previewEl) {
            previewEl.addEventListener("click", (e) => {
                if (this.form.getClosestAnchor(e.target)) return;
                this.handler.handleOpenClick(e);
            });
        }

        if (clearBtn) {
            clearBtn.addEventListener("click", this.handler.handleClearClick.bind(this.handler));
        }

        if (searchInput) {
            searchInput.addEventListener("search-menu:product-selected", (event: Event) => {
                this.handler.handleProductSelected(event as CustomEvent<{ product?: ProductLinkerProduct }>);
            });
        }
    }
}

export { ProductLinkerListener };
